import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  ListGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getDepartmentList,
  postWorkingDay,
  postPersonnelByDepartment,
  updatePersonnelByDepartment,
  updateWorkingDay,
  postDepartmentExcel,
  resetDepartmentReport,
} from "./DepartmentSlice";
import Select from "react-select";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import { triggerBase64Download } from "common-base64-downloader-react";
import Footer from "../../UI/Footer";

function DepartmentComponent() {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const { workingDay2, departmentReport } = useSelector(
    (state) => state.DepartmentSlice
  );
  const [table, setTable] = useState([]);
  const { fromdate, todate } = workingDay2;
  const { departments } = departmentReport;
  const [workDay, setWorkDay] = useState(0);
  const [total, setTotal] = useState({
    onTimeTotal: 0,
    lateTotal: 0,
    absentTotal: 0,
    leaveTotal: 0,
  });

  useEffect(() => {
    dispatch(getDepartmentList()).then((res) => {
      console.log(res);
      const arr = [];
      let result = res.payload;
      result.map((department) => {
        return arr.push({
          value: department.departments.id,
          label: department.departments.description,
        });
      });
      console.log(result);
      setList(arr);
    });
  }, []);

  const handleChangeForm = (e) => {
    const entity = { ...workingDay2, [e.target.name]: e.target.value };
    dispatch(updateWorkingDay(entity));
  };
  const handleChangeDropdownDepartmentName = (selectedOption) => {
    console.log(selectedOption);
    const entity = {
      ...departmentReport,
      departments: { id: selectedOption.value },
    };
    dispatch(updatePersonnelByDepartment(entity));
    console.log(entity);
  };
  const handleClickSearch = () => {
    const entity = { ...departmentReport, fromdate: fromdate, todate: todate };
    const entity2 = { ...workingDay2 };
    console.log(entity);
    console.log(entity2);
    dispatch(postPersonnelByDepartment(entity)).then((res) => {
      let totalOnTime = 0;
      let totalLate = 0;
      let totalAbsent = 0;
      let totalLeave = 0;
      res.payload.forEach((res) => {
        console.log(res);
        totalOnTime += +res.is_on_time;
        totalLate += +res.is_late;
        totalAbsent += +res.absent_days;
        totalLeave += +res.is_before5;
      });
      setTotal({
        onTimeTotal: totalOnTime,
        lateTotal: totalLate,
        absentTotal: totalAbsent,
        leaveTotal: totalLeave,
      });
      setTable(res.payload);
    });
    dispatch(postWorkingDay(entity2)).then((res) => {
      console.log(res);
      console.log(res.payload);
      setWorkDay(res.payload.total_working);
    });
  };

  const handleExportExcel = () => {
    const entity = { ...departmentReport, fromdate: fromdate, todate: todate };
    console.log(entity)
    dispatch(postDepartmentExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload;
      triggerBase64Download(
        base64EXCEL,
        "department_report" + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleBack = () => {
    const entity = { ...departmentReport };
    dispatch(resetDepartmentReport(entity));
    setTable([]);
    setTotal({
      onTimeTotal: 0,
      lateTotal: 0,
      absentTotal: 0,
      leaveTotal: 0,
    });
    setWorkDay(0);
  };

  return (
    <div className="Div">
      <Container fluid>
      <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col xs={2} id="sidebar-wrapper" className="sidemenu"  style={{ marginTop: "50px" }}>
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>DEPARTMENT REPORT</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>SEARCH DEPARTMENT:</Col>
                    <Col md={9}>
                      <Select
                        options={list}
                        onChange={handleChangeDropdownDepartmentName}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>FROM DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="fromdate"
                        value={fromdate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                    <Col md={3}>
                      <Form.Label>TO DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="todate"
                        value={todate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <hr />
                    </Col>
                  </Row>
                  <Row className="mt-3 mb-3">
                    <Col md={3}>TOTAL WORKING DAYS:</Col>
                    <Col md={9}>
                      <ListGroup>
                        <ListGroup.Item>{workDay}</ListGroup.Item>
                      </ListGroup>
                    </Col>
                  </Row>
                  <Card>
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>NO.</th>
                          <th>NAME</th>
                          <th>DAY ON TIME</th>
                          <th>DAY LATE</th>
                          <th>DAY ABSENT</th>
                          <th>DAY LEAVE EARLIER</th>
                        </tr>
                      </thead>
                      <tbody>
                        {table.map(
                          (
                            {
                              fullname,
                              is_on_time,
                              is_late,
                              absent_days,
                              is_before5,
                            },
                            i
                          ) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{fullname}</td>
                              <td>{is_on_time}</td>
                              <td>{is_late}</td>
                              <td>{absent_days}</td>
                              <td>{is_before5}</td>
                            </tr>
                          )
                        )}
                        <tr style={{ fontWeight: "bold" }}>
                          <td></td>
                          <td>TOTAL</td>
                          <td>{parseFloat(total?.onTimeTotal)}</td>
                          <td>{parseFloat(total?.lateTotal)}</td>
                          <td>{parseFloat(total?.absentTotal)}</td>
                          <td>{parseFloat(total?.leaveTotal)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mt-3 mb-3">
                    <Col md={1}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Export Excel Report
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default DepartmentComponent;
